import { isActiveMembership } from '~/core/util/account';
import { useAccount } from '~/hooks/account/useAccount';

/**
 * Returns whether an account holder is a solv plus member (excluding user profile eligibility).
 *
 * @returns boolean
 */
export function useIsMember() {
  const account = useAccount();
  return isActiveMembership(account);
}
